/**
 * Created by kk on 17/7/18.
 */
export const user = state => state.user
export const token = state => state.token
export const error = state => state.error
export const isSmallScreen = state => state.winSize[0] < 640
